module.exports = __webpack_public_path__ + "img/bus-vector.e84ddc3e.svg";